module.exports = __webpack_public_path__ + "img/logout_icon.32348756.svg";